import { render, staticRenderFns } from "./muvLayer.vue?vue&type=template&id=0da49ccc&"
import script from "./muvLayer.vue?vue&type=script&lang=js&"
export * from "./muvLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports